import RequestSender from '../RequestSender';
import { HOST, API_PREFIX } from './host';
import { isDevMode, getDevAgencyDomain } from '@/utils/devAgency';
export default class GetRequest {
    constructor() {
        this.requestInitPart = {};
        this.timeout = 15000;
    }
    get requestInit() {
        const { requestInitPart } = this;
        const headers = {
            ...requestInitPart.headers,
        };
        if (isDevMode) {
            const devDomain = getDevAgencyDomain();
            if (devDomain) {
                headers['X-Agency-Domain'] = devDomain;
            }
        }
        return {
            ...requestInitPart,
            method: 'GET',
            // credentials: 'include' as RequestCredentials,
            headers,
        };
    }
    async send() {
        const { url, requestInit, timeout, responseHandler } = this;
        const response = await RequestSender.sendRequest(`${HOST}${API_PREFIX}${url}`, requestInit, timeout);
        const data = await responseHandler.handleResponse(response);
        return data;
    }
}
